import { createElement } from "react"
import { Head, usePage } from "@inertiajs/react"

const SEO = () => {
  const { _inertia_meta: meta } = usePage().props as any

  if (!meta) return null

  return (
    <Head>
      {meta.map((meta: any) => {
        const { tagName, innerContent, headKey, httpEquiv, ...attrs } = meta

        let stringifiedInnerContent
        if (innerContent != null) {
          stringifiedInnerContent =
            typeof innerContent === "string"
              ? innerContent
              : JSON.stringify(innerContent)
        }

        return createElement(tagName, {
          key: headKey,
          "head-key": headKey,
          ...(httpEquiv ? { "http-equiv": httpEquiv } : {}),
          ...attrs,
          ...(stringifiedInnerContent
            ? { dangerouslySetInnerHTML: { __html: stringifiedInnerContent } }
            : {}),
        })
      })}
    </Head>
  )
}

export default SEO
